import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      @media screen and ", " {\n        padding-bottom: ", ";\n      }\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  left: ", ";\n  position: absolute;\n  top: 6px;\n  z-index: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled, { css } from 'styled-components';
import { useMediaQuery } from 'react-responsive';
import { SkipLink } from '@scp/ui-shared/components/buttons';
import { mediaQueryTabletMax } from '@scp/ui-shared/theme/responsive';
import { baselineToPx } from '@scp/ui-shared/theme/utils';
import { zIndex } from '@scp/ui-shared/theme/variables'; // eslint-disable-next-line import/no-relative-parent-imports

import { FullscreenLayoutBase } from '../FullscreenLayoutBase';
import { CenterColumn, HeaderShadow, LeftColumn, MainContent, MainScreen, RightColumn, SkipWrapper } from './baseComponents';
import { MAIN_CONTENT_ID, TEXT } from './constants';
var ToggleWrapper = styled.div(_templateObject(), baselineToPx(1), zIndex.appBar);
var ResponsiveMainScreen = styled(MainScreen)(_templateObject2(), function (props) {
  return props.$showBottomNav && css(_templateObject3(), mediaQueryTabletMax, baselineToPx(15));
});
export var ScreenLayoutResponsive = function ScreenLayoutResponsive(_ref) {
  var children = _ref.children,
      leftColumn = _ref.leftColumn,
      sideNavigation = _ref.sideNavigation,
      rightColumn = _ref.rightColumn,
      _ref$fixedRightSideba = _ref.fixedRightSidebarWidth,
      fixedRightSidebarWidth = _ref$fixedRightSideba === void 0 ? true : _ref$fixedRightSideba,
      bottomNavigation = _ref.bottomNavigation,
      toggleMenuHandler = _ref.toggleMenuHandler;
  var isTablet = useMediaQuery({
    query: mediaQueryTabletMax
  });
  return React.createElement(React.Fragment, null, !isTablet && React.createElement(SkipWrapper, null, React.createElement(SkipLink, {
    skipToId: MAIN_CONTENT_ID,
    title: TEXT.SKIP_LINK
  })), React.createElement(FullscreenLayoutBase, null, isTablet && React.createElement(ToggleWrapper, null, toggleMenuHandler), !!sideNavigation && sideNavigation, React.createElement(ResponsiveMainScreen, {
    "$showBottomNav": !!bottomNavigation
  }, React.createElement(MainContent, {
    id: MAIN_CONTENT_ID
  }, !!leftColumn && !isTablet && React.createElement(LeftColumn, null, leftColumn), React.createElement(CenterColumn, null, children)), rightColumn && !isTablet && React.createElement(RightColumn, {
    fixedWidth: fixedRightSidebarWidth
  }, rightColumn), React.createElement(HeaderShadow, null), !!bottomNavigation && bottomNavigation)));
};